var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-wrapper',[_c('app-banner'),_c('app-wrapper',{staticClass:"team",attrs:{"content":true}},_vm._l((_vm.$state.page.profiles),function(item,index){return _c('app-profile',{key:index,attrs:{"item":item,"button":true}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }